import { render, staticRenderFns } from "./BankStatementView.vue?vue&type=template&id=10ee88f3"
import script from "./BankStatementView.vue?vue&type=script&lang=js"
export * from "./BankStatementView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports